import React, { Component } from 'react';
//import { actionTypes } from '../../constants.js';
//import { sortArray } from '../helpers/HelperFunctions.js';
import { TableColumn } from './TableColumn.js';
export class TableRow extends Component {
    constructor(props) {
        super(props);
        //this.state = {
        //    checked: false
        //};
        //this.handlerCheck = this.handlerCheck.bind(this);
        //this.onRowClick = this.onRowClick.bind(this);
        //this.onRowDoubleClick = this.onRowDoubleClick.bind(this);
        //this.onDocLinkClick = this.onDocLinkClick.bind(this);
    }
    componentDidMount() {
        //const { item } = this.props;
        //const currentObject = this;
        //var row = document.getElementById("table_row_" + item.columns.Id);
        //row.addEventListener("contextmenu", function (event) {
        //    event.preventDefault();
        //    var ckeckBox = document.getElementById(item.columns.Id);
        //    ckeckBox.checked = !ckeckBox.checked;
        //    currentObject.handlerCheck({ target: ckeckBox });
        //}, false);
    }
    renderCols(item, cols) {
        if (!item || !cols)
            return '';
        return (
            [
                cols.map((col) => (
                    <TableColumn col={col} key={col.name} value={item.columns[col.name]} />
                ))
            ]
        );
    }
    render() {
        const { children, cols, item } = this.props;
        if (cols && item)
            return (
                <tr id={"table_row_" + item.columns.Id}>
                    {this.renderCols(item, cols)}                    
                </tr>
            );
        return (
            <tr>
                {children}
            </tr>
        );
    }
}
